<template>
  <Header
    :theme="theme"
    :user="user"
    :state="state"
    :logoImg="themeImages.logo"
    :logoAlt="themeName"
    :loginUrl="`${$env.RussiaRunning}/login`"
    :menu="menu"
    :mobileMenu="menu"
    :profileMenu="profileMenu"
    :live="isLive"
    :liveUrl="isLive ? $env.Live : ''"
    :moreButtonText="$t('nav.more')"
    :logoutUrl="`${$env.RussiaRunning}/Auth/LogOff`"
    logoutText="Выйти"
    :isFlagsLang="false"
    logoUrl="https://market.tulamarathon.org/"
    align="center"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import Header from '../../Header/Header.vue';

export default {
  name: 'tulaHeader',
  components: {
    Header,
  },

  data() {
    return {
      user: null,
      isAuthorized: false,
      menu: [
        {
          id: 1,
          text: 'События',
          href: '/events',
          icon: 'calendar',
          open: false,
          itemsOnlyMobile: true,
          active: true,
          items: [
            {
              text: 'Предстоящие',
              href: `${this.$env.RussiaRunning}/events`,
            },
            {
              text: 'Идут сегодня',
              href: window.location.hostname === 'localhost' ? '/events?e=1' : `${this.$env.RussiaRunning}/events?e=1`,
              hidden: window.vm?.AnyCurrentEvents === false,
            },
            {
              text: 'Прошедшие',
              href: this.$env.Results,
            },
          ],
        },
        {
          id: 2,
          text: 'Результаты',
          href: this.$env.Results,
          icon: '1st-place-medal',
        },
      ],
      profileMenu: [
        {
          name: 'Профиль',
          icon: 'user',
          link: `${this.$env.RussiaRunning}/Account`,
        },
        {
          name: 'Регистрация',
          icon: 'badge',
          link: `${this.$env.RussiaRunning}/Account/RegistrationList`,
        },
        {
          name: 'Заказы',
          icon: 'shopping-bag',
          link: `${this.$env.RussiaRunning}/Account/OrderList`,
        },
        {
          name: 'Команды',
          icon: 'team',
          link: `${this.$env.RussiaRunning}/Account/MyTeams`,
        },
        {
          isDivider: true,
          hidden: !window.userInfo || (!window.userInfo.IsAdmin && !window.userInfo.IsBeneficiary),
        },
        {
          name: 'Организаторам',
          icon: 'caret-right',
          link: window.userInfo && window.userInfo.AdminUrl,
          hidden: !window.userInfo || (!window.userInfo.IsAdmin && !window.userInfo.IsBeneficiary),
        },
        {
          name: 'Счета',
          icon: 'caret-right',
          link: `${this.$env.RussiaRunning}/Account/Bills`,
          hidden: !window.userInfo || !window.userInfo.IsAdmin,
        },
        {
          name: 'Кэш',
          icon: 'caret-right',
          link: `${this.$env.RussiaRunning}/CacheAdmin`,
          hidden: !window.userInfo || !window.userInfo.IsAdmin,
        },
      ],
      isLive: false,
    };
  },
  methods: {
    getLiveCount() {
      // const url = process.env.NODE_ENV === 'development' ? '' : this.$env.RussiaRunning;
      return axios('/api/events/live-count', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
        .then((response) => {
          if (response.data > 0) {
            this.isLive = true;
          }
        });
    },
  },
  computed: {
    ...mapGetters('settings', ['theme', 'themeImages', 'themeName']),
    state() {
      if (this.isAuthorized) {
        return 'authorized';
      }
      return 'unauthorized';
    },
  },
  mounted() {
    this.getLiveCount();
  },
  created() {
    this.user = window.userInfo;
    this.isAuthorized = !!this.user;
  },
};
</script>
